import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColissimo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#F7A600"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(7 7) scale(0.020434) translate(76.943 16.940)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M505,378c-3.4,2-8.8,1.8-12.1-0.2l-19.7-11.7c-1.6-1-3.1-2.6-4.2-4.5c-0.1-0.1-0.1-0.2-0.2-0.3\n	c-1.3-2-2-4.2-2-6.2l-0.5-22.9c-0.1-3.9,2.4-8.6,5.8-10.6l236.4-137.7L376.8,3c-3.7-2-8.5-3-13.3-3c-4.8,0-9.7,1-13.3,3L18.4,183.8\n	l371.7,216.4c3.4,1.9,6.1,6.4,6.1,10.4l0,315.7c0,4-2.8,8.5-6.3,10.4l-20,11.1c-1.7,0.9-3.8,1.4-6,1.4c-0.1,0-0.3,0-0.4,0\n	c-2.4,0.1-4.6-0.4-6.4-1.4L337,736.6c-3.4-1.8-6.2-6.4-6.2-10.4l0-281.4c-0.2-2.1-1.7-4.6-3.3-5.5L0,248.7l0,373.4\n	c0,8.4,5.9,18.7,13.1,22.9l337.3,198.9c3.6,2.1,8.4,3.2,13.1,3.1c4.7,0,9.5-1,13.1-3.1L713.9,645c7.2-4.3,13.1-14.5,13.1-22.9V248.7\n	L505,378z",
			fill: "#fff"
		}), /* @__PURE__ */ _jsx("g", {})]
	})]
});
export default SvgColissimo;
